var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBellWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 58,
    viewBox: "0 0 61 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_122_553",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 61,
    height: 58
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.255249 0.296875H60.1667V57.2083H0.255249V0.296875Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_122_553)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.125 4.79167L12.0521 0.71875C5.22921 5.91667 0.729208 13.9375 0.302124 23.0625H6.00004C6.43754 15.5208 10.3282 8.91667 16.125 4.79167ZM54.2813 23.0625H59.974C59.5469 13.9375 55.0469 5.91667 48.224 0.71875L44.1667 4.77604C49.948 8.91667 53.8386 15.5208 54.2813 23.0625ZM48.6511 24.4844C48.6511 15.7344 42.573 8.43229 34.4115 6.5V4.5625C34.4115 2.20313 32.5052 0.296875 30.1407 0.296875C27.7761 0.296875 25.8646 2.20313 25.8646 4.5625V6.5C17.7032 8.43229 11.625 15.7344 11.625 24.4844V40.1354L5.92712 45.8281V48.6719H54.349V45.8281L48.6511 40.1354V24.4844ZM30.1407 57.2083C30.5365 57.2083 30.9219 57.1667 31.2917 57.0938C33.1459 56.7135 34.6667 55.4323 35.3959 53.7396C35.6771 53.0573 35.8334 52.3177 35.8334 51.5208H24.4427C24.4427 54.6615 26.9896 57.2083 30.1407 57.2083Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellWhite);
export default __webpack_public_path__ + "static/media/bell-white.f2f78728de3e662ae2fa4a180e85cfca.svg";
export { ForwardRef as ReactComponent };